// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": "#863695",
	"secondary": "#547688",
	"success": "#009245",
	"siteBlue": "#140fa5",
	"siteGreen": "#0a8735",
	"liteGreen": "#00be41",
	"siteLiteBlue": "#0078cd",
	"sitePurple": "#8c199b",
	"secondaryBright": "#e3e3e3",
	"accent": "#30556b",
	"textColor": "#333",
	"black": "#000",
	"neutralLight": "#f4f4f4",
	"neutralBright": "#fbfbfb",
	"textLinks": "#fff",
	"brandGrey": "#50504f"
};
module.exports = ___CSS_LOADER_EXPORT___;
